import React from "react";
import { getSpaceChildren, getSpacePresentation } from "../spatialModel";

function displayType(value) {
  return value ? value.replaceAll("_", " ") : "Space";
}

function SpaceBranch({ spaces, depth, selectedSpaceId, onSelect }) {
  return spaces.map((space) => {
    const presentation = getSpacePresentation(space);
    const selected = selectedSpaceId === space.id;
    const children = getSpaceChildren(space);

    return (
      <li className="digital-twin-space-branch" key={space.id}>
        <button
          type="button"
          className={`digital-twin-space-row${selected ? " is-selected" : ""}`}
          style={{ "--space-depth": depth }}
          aria-current={selected ? "true" : undefined}
          onClick={() => onSelect(space.id)}
        >
          <span className="digital-twin-tree-marker" aria-hidden="true" />
          <span className="digital-twin-space-row-label">{presentation.label}</span>
          <span className="digital-twin-space-row-type">{displayType(space.type)}</span>
        </button>
        {children.length > 0 && (
          <ul className="digital-twin-space-children">
            <SpaceBranch
              spaces={children}
              depth={depth + 1}
              selectedSpaceId={selectedSpaceId}
              onSelect={onSelect}
            />
          </ul>
        )}
      </li>
    );
  });
}

export default function SpaceNavigator({ spaces, selectedSpaceId, onSelect, user, onLogout, showAccountAction = true }) {
  return (
    <section className="digital-twin-navigator" aria-labelledby="twin-spaces-title">
      <div className="digital-twin-section-heading">
        <div>
          <div className="digital-twin-kicker">Declarative model</div>
          <h2 id="twin-spaces-title">Spaces</h2>
        </div>
        {showAccountAction ? (
          <div className="digital-twin-navigator-actions">
            {user ? (
              <button className="digital-twin-account-action" type="button" onClick={onLogout}>Sign out</button>
            ) : (
              <a className="digital-twin-account-action" href="/login">Login</a>
            )}
          </div>
        ) : (
          <span className="digital-twin-count">{spaces.length} root{spaces.length === 1 ? "" : "s"}</span>
        )}
      </div>
      {spaces.length > 0 ? (
        <ul className="digital-twin-space-tree">
          <SpaceBranch
            spaces={spaces}
            depth={0}
            selectedSpaceId={selectedSpaceId}
            onSelect={onSelect}
          />
        </ul>
      ) : (
        <p className="digital-twin-empty">No declarative spaces are available.</p>
      )}
    </section>
  );
}